'use client';

import dynamic from 'next/dynamic';

const CookieConsentBanner = dynamic(() => import('components/cookie-consent-banner'), {
  ssr: false,
  loading: () => null,
});

export default function ClientCookieBanner(): React.ReactElement {
  return <CookieConsentBanner />;
}
